import { render } from "./sub-header-wrapper.vue?vue&type=template&id=fb45aae0&scoped=true"
import script from "./sub-header-wrapper.vue?vue&type=script&lang=js"
export * from "./sub-header-wrapper.vue?vue&type=script&lang=js"

import "./sub-header-wrapper.vue?vue&type=style&index=0&id=fb45aae0&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb45aae0"],['__file',"src/components/sub-header-wrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fb45aae0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fb45aae0', __exports__)) {
    api.reload('fb45aae0', __exports__)
  }
  
  module.hot.accept("./sub-header-wrapper.vue?vue&type=template&id=fb45aae0&scoped=true", () => {
    api.rerender('fb45aae0', render)
  })

}


export default __exports__